/** Label for a person referenced in history (submitted by, checked by…).
 *  Accounts are never hard-deleted, so the name survives people leaving. */
export function actorLabel(name: string | null | undefined, active: boolean | null | undefined): string {
  if (!name) return 'Unknown';
  return active === false ? `${name} (former member)` : name;
}
